import React, { useEffect, useState } from "react";

import { ReactComponent as AutoRollSVG } from "../../../assets/auto.svg";
import { ReactComponent as RandomSVG } from "../../../assets/random.svg";
import {
  FooterContainer,
  FooterRow,
  OperationBtn,
  BalanceBtn,
  MainBtn,
  Stop,
} from "./FooterStyled";

import useBetOperations from "../../bets";
import currencies from "../../helpers/getCurrency";
export default ({
  betCount,
  betTotal,
  bet,
  userSelected,
  isAutoOn,
  manualPlay,
  cashout,
  handleAbove,
  handleBetAmount,
  handleNotification,
  handleStartRound,
  handleRandomGameStep,
  handleCashout,
  handleStop,
  result,
  handleAboveAnim,
  userInfo,
  toggleIsDisabled,
  currencyIcon,
  isDisabled,
  userSettings,
  audio,
  gameStates,
  newDisable,
}) => {
  const { minBet, maxBet, curr, precision, maxWin } = userInfo;
  const [ubet, , , multiply, divide] = useBetOperations(
    bet,
    userSettings.volume,
    userSettings.sound,
    handleNotification,
    minBet,
    maxBet,
    curr,
    precision
  );

  const [border, setBorder] = useState(false);

  const [stopAnim, setStopAnim] = useState(false);

  const [clickAnimation, setClickAnimation] = useState("");

  const [buttonWidth, setButtonWidth] = useState(false);
  useEffect(() => {
    handleBetAmount(ubet);
  }, [ubet, handleBetAmount]);

  useEffect(() => {
    if (!userSelected.length === 0 || !userSelected.includes("")) {
      setBorder(true);
    } else {
      setBorder(false);
    }
  }, [userSelected]);

  const Play = (e) => {
    handleStartRound(e);
  };

  const Cashout = () => {
    if (userSelected.length === 0 || userSelected.includes("")) {
      handleNotification(
        "Unable to cashout unless you make at least 1 selection"
      );
    } else {
      handleNotification(false);
      border && audio.cashout();
      handleCashout();
    }
  };
  const setStopAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 1000);
    }
  };

  const handleClick = () => {
    setClickAnimation("play");
    if (manualPlay) {
      audio.pickRandom();
      handleRandomGameStep();
    } else {
      audio.play();
      setTimeout(() => {
        Play(ubet);
      }, 100);
    }
  };
  const handleOperation = () => {
    if (manualPlay) {
      border && setClickAnimation("operation");
      setTimeout(() => {
        Cashout();
      }, 100);
    } else {
      setClickAnimation("operation");
      audio.goForward();
      setTimeout(() => {
        handleAbove("autoConfig");
        handleAboveAnim(true);
      }, 100);
    }
  };

  useEffect(() => {
    if (gameStates === "started") {
      setButtonWidth(true);
    } else {
      setButtonWidth(false);
    }
  }, [gameStates]);

  /// need change
  useEffect(() => {
    if (clickAnimation !== "") {
      setTimeout(() => {
        setClickAnimation("");
      }, 333);
    }
  }, [clickAnimation]);

  useEffect(() => {
    if (Number(cashout) >= Number(maxWin)) {
      handleNotification(`You Have Reached  Max Win Amount of ${maxWin + currencies[curr]}, you can't win anymore in this round so please, cash out and begin a new Round!`)
    }
  }, [cashout, handleNotification, curr, maxWin])

  return (
    <FooterContainer isDisabled={result || isDisabled}>
      {isAutoOn ? (
        <Stop
          handleStop={handleStop}
          setStopAnimation={() => setStopAnimation(stopAnim, setStopAnim)}
          toggleIsDisabled={toggleIsDisabled}
          stopAnim={stopAnim}
          betTotal={betTotal}
          betCount={betCount}
          ubet={ubet}
          currencyIcon={currencies[curr]}
          playStopSFX={audio.cashout}
        />
      ) : (
        <>
          <FooterRow rowAnim={manualPlay} className="row">
            <OperationBtn
              clickAnim={clickAnimation === "divide"}
              newDisable={newDisable}
              onClick={() => {
                setClickAnimation("divide");
                divide();
              }}
            >
              1/2
            </OperationBtn>
            <BalanceBtn
              clickAnim={clickAnimation === "setBet"}
              isDisabled={isDisabled}
              onClick={() => {
                setClickAnimation("setBet");
                audio.goForward();
                setTimeout(() => {
                  handleAbove("setBet");
                  handleAboveAnim(true);
                }, 100);
              }}
            >
              <p>
                {ubet} {currencies[curr]}{" "}
              </p>
            </BalanceBtn>
            <OperationBtn
              newDisable={newDisable}
              clickAnim={clickAnimation === "multiply"}
              onClick={(e) => {
                setClickAnimation("multiply");
                multiply();
              }}
            >
              2x
            </OperationBtn>
          </FooterRow>
          <FooterRow>
            <MainBtn
              clickAnim={clickAnimation === "play"}
              btnAnim={buttonWidth}
              isStoped={stopAnim}
              onClick={() => handleClick()}
              newDisable={newDisable}
            >
              <RandomSVG />
              <p>PLAY</p>
              <span>STOP</span>
            </MainBtn>
            <OperationBtn
              btnAnim={buttonWidth}
              newDisable={newDisable}
              clickAnim={clickAnimation === "operation"}
              onClick={() => handleOperation()}
              border={!border && manualPlay}
              isStoped={stopAnim}
            >
              <AutoRollSVG className="autoRoll" />
              <div className="cashout">
                <p>CASHOUT</p>
                <span>
                  {cashout} {currencies[curr]}
                </span>
              </div>
            </OperationBtn>
          </FooterRow>
        </>
      )}
    </FooterContainer>
  );
};
